/* ============
 * Axios
 * ============
 *
 * Promise based HTTP client for the browser and node.js.
 * Because Vue Resource has been retired, Axios will now been used
 * to perform AJAX-requests.
 *
 * https://github.com/mzabriskie/axios
 */

import Vue from 'vue';
import Axios from 'axios';
import store from '@/store';

const instance = Axios.create();
instance.defaults.baseURL = process.env.API_DESKRH;
instance.defaults.headers.common.Accept = 'application/json';
instance.interceptors.response.use(
  response => response,
  (error) => {
    if (error.response.status === 401) {
      store.dispatch('auth/logout');
    }

    return Promise.reject(error);
  });

// Bind Axios to Vue.
Vue.$http = instance;
Object.defineProperty(Vue.prototype, '$http', {
  get() {
    return instance;
  },
});


// TO DO: replace 'session' by 'sessionDeskDaf' when we'll get the api route for deskDaf

// const token = '151523456218';
const tokenDeskDaf = JSON.parse(localStorage.getItem('session'));
export const HTTP_DESKDAF = Axios.create();
HTTP_DESKDAF.defaults.baseURL = process.env.API_DESKDAF;
if (tokenDeskDaf) {
  HTTP_DESKDAF.defaults.headers.common.Authorization = tokenDeskDaf;
}

// Axios used with edocSign APIs

const token = '151523456218';
// const token = JSON.parse(localStorage.getItem('sessionEdocSign'));

export const HTTP_EDOCSIGN = Axios.create();
HTTP_EDOCSIGN.defaults.baseURL = process.env.API_SIGN;
HTTP_EDOCSIGN.interceptors.response.use(
  (response) => {
    if (JSON.stringify(response.data).includes('session not valid')) {
      store.dispatch('auth/logoutEdocSign');
    }
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch('auth/logoutEdocSign');
    }

    return Promise.reject(error);
  });

if (token) {
  HTTP_EDOCSIGN.defaults.headers.common.Authorization = token;
}



// WEBPACK FOOTER //
// ./src/plugins/axios.js